import React, { Component } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { toWapi } from '../util/api';
import _ from 'lodash';
import moment from 'moment';
import { Typography, LinearProgress, linearProgressClasses, Divider, Box, Grid, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import styled from '@emotion/styled';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
	},
}));

class AccountProgress extends Component {
	state = {
		totalPhones: 0,
		loading: true,
		phones: [],
	};

	async componentDidMount() {
		let { product } = this.props;
		let pid = product.id;
		if (product.settings === null || !product.settings.subscription_package || !product.settings.subscription_package) {
			return this.setState({ _loading: false });
		}
		if (product.settings.wapi_token) {
			let uri = `https://api.maytapi.com/api/${product.id}/product?token=${product.settings.wapi_token}`;
			let data = await fetch(uri, { headers: { 'Content-Type': 'application/json' }, method: 'get' }).then((it) => it.json());
			this.setState({ wapiData: data });
		}
		toWapi(`/api/${pid}/listPhones`, product.settings.wapi_token)
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				data = data.data;
				this.setState({ loading: false, phones: data });
			})
			.catch((err) => {
				console.error(err);
				this.setState({ loading: false });
			});
	}
	render() {
		let products = this.props.product;
		let defaultWebhook = 'https://api.maytapi.com/webhook/live/send/' + products.settings.live.token;
		let webhook = this.state.wapiData && this.state.wapiData.webhook;
		/* let isActivePhone = _.filter(this.state.phones, function (it) {
			return it.status === 'active';
		}); */
		var stepsLive = [
			{
				icon: 'bullhorn',
				title: 'Subscribe',
				description: 'Start trial.',
				completed: !!this.props.product.settings.subscription_package,
				link: '/subscription',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Phone',
				description: 'Add first phone.',
				completed: !!this.state.phones.length,
				link: '/phones',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'QR',
				description: 'Pair your phone by reading QR',
				completed: !!_.find(this.state.phones, { status: 'active' }),
				link: '/phones',
				show: true,
			},
			// {
			// 	icon: 'user',
			// 	title: 'Profile Settings',
			// 	description: 'Fill user information.',
			// 	sub: {
			// 		name: this.props.user.name,
			// 		company: this.props.user.company,
			// 		phone: this.props.user.phone,
			// 	},
			// 	completed: !!(this.props.user.name && this.props.user.company && this.props.user.phone),
			// 	link: '/settings/account',
			// 	show: true,
			// },
			// {
			// 	icon: 'bullhorn',
			// 	title: 'Phone',
			// 	description: 'Activate first phone.',
			// 	completed: isActivePhone && isActivePhone.length > 0,
			// 	link: '/phones',
			// 	show: true,
			// },
			{
				icon: 'bullhorn',
				title: 'Agent',
				description: 'Add Agent',
				completed: this.props.product.settings.subscription_package && this.props.product.settings.subscription_package !== 'api',
				link: '/agents',
				show: this.props.product.settings.subscription_package !== 'api',
			},
		];

		const extraLive = [
			{
				icon: 'user',
				title: 'Profile Settings',
				description: 'Fill user information.',
				sub: {
					name: this.props.user.name,
					company: this.props.user.company,
					phone: this.props.user.phone,
				},
				completed: !!(this.props.user.name && this.props.user.company && this.props.user.phone),
				link: '/settings/account',
				show: true,
			},
		];

		var stepsApi = [
			{
				icon: 'bullhorn',
				title: 'Subscribe',
				description: 'Start trial.',
				completed: !!this.props.product.settings.subscription_package,
				link: '/subscription',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Phone',
				description: 'Add first phone.',
				completed: !!this.state.phones.length,
				link: '/phones',
				show: true,
			},
			// {
			// 	icon: 'user',
			// 	title: 'Profile Settings',
			// 	description: 'Fill user information.',
			// 	sub: {
			// 		name: this.props.user.name,
			// 		company: this.props.user.company,
			// 		phone: this.props.user.phone,
			// 	},
			// 	completed: !!(this.props.user.name && this.props.user.company && this.props.user.phone),
			// 	link: '/settings/account',
			// 	show: true,
			// },
			{
				icon: 'bullhorn',
				title: 'QR',
				description: 'Pair your phone by reading QR',
				completed: !!_.find(this.state.phones, { status: 'active' }),
				link: '/phones',
				show: true,
			},
			// {
			// 	icon: 'bullhorn',
			// 	title: 'Phone',
			// 	description: 'Activate first phone.',
			// 	completed: isActivePhone && isActivePhone.length > 0,
			// 	link: '/phones',
			// 	show: true,
			// },
			{
				icon: '',
				title: 'Webhook',
				description: 'Set your webhook.',
				completed: defaultWebhook !== webhook,
				link: '/developers/webhook',
				show: true,
			},
		];
		var steps = [];
		if (
			(this.props.product && this.props.product.settings && this.props.product.settings.subscription_package === 'api') ||
			this.props.product.settings.subscription_package === 'maytapi-trial-api'
		) {
			steps = stepsApi;
		} else {
			steps = stepsLive;
		}
		if (this.state.loading) {
			return (
				<Typography variant="h3">
					<Icon name={this.props.icon} />
					<Typography>{this.props.title}</Typography>
				</Typography>
			);
		}
		var trials = { 'maytapi-trial-api': 'API', 'maytapi-trial-live': 'LiveChat' };
		const percentage = ((_.filter(steps, { completed: true }).length / steps.length) * 100).toFixed();
		//const color = percentage === '100' ? '#21BA45' : '#57BAE4';
		let expiredTrialType =
			products.trial === false &&
			products.deletedSubs &&
			products.deletedSubs[0] &&
			products.deletedSubs[0].data.trialType &&
			trials[products.deletedSubs[0].data.trialType];
		let subscription = products.settings && products.settings.subscription_package && trials[products.settings.subscription_package];
		let trialEndDate = products.activeSubs[0] && moment(products.activeSubs[0].created_at).startOf('day').add('3', 'days');
		let diffDate = moment(trialEndDate).diff(moment().startOf('day'), 'days');
		//let marginRightAuto = percentage === '100' ? 'auto' : '0';
		return (
			<>
				{/* <Header as="h3" style={{ marginRight: '15px' }}>
					<Icon name={this.props.icon} />
					<Header.Content>{this.props.title}</Header.Content>
				</Header> */}
				{products.trial ? (
					<div id="none-buttons" style={{ margin: '0 20px 0 0' }}>
						<p style={{ color: 'black', margin: '0' }}>
							{'Your ' + subscription + ' trial will over'} {diffDate > 0 ? diffDate + ' days later.' : 'today'}
						</p>
						<div style={{ textAlign: 'center' }}>
							<Button id="none-buttons" size="mini" className="pageMessage" as="a" href="/subscription" positive>
								Purchase
							</Button>
							<Button id="none-buttons" size="mini" className="pageMessage" as="a" href="/contact" primary>
								Contact Us
							</Button>
						</div>
					</div>
				) : products.trial === false && !(products.activeSubs && products.activeSubs.length) ? (
					<div id="none-buttons" style={{ margin: '0 20px 0 0' }}>
						<p style={{ color: 'black', margin: '0' }}>
							{expiredTrialType ? 'Your ' + expiredTrialType + ' trial is over.' : 'Your trial is over.'}
						</p>
						<div style={{ textAlign: 'center' }}>
							<Button id="none-buttons" className="pageMessage" as="a" href="/subscription" positive>
								Purchase
							</Button>
							<Button id="none-buttons" className="pageMessage" as="a" href="/contact" primary>
								Contact Us
							</Button>
						</div>
					</div>
				) : (
					''
				)}
				{percentage !== '100' ? (
					<div
						style={{
							height: '40px',
							width: '50px',
							background: '#c54949',
							borderRadius: '5px',
							padding: '0',
							cursor: 'pointer',
						}}
					>
						<Popup
							trigger={
								<div style={{ width: '100%', height: '100%', textAlign: 'center', alignItems: 'center', display: 'grid' }}>
									<h1 style={{ color: 'white', fontSize: '14px' }}>{`${Math.round(percentage)}%`}</h1>
								</div>

								// <div style={{ margin: '8px 10px auto auto' }}>
								// 	<h1 style={{ color: color, fontSize: '23px' }}>%{percentage}</h1>
								// </div>
							}
							position="top right"
							style={{ textAlign: 'center', marginRight: '5px', maxWidth: '60vh' }}
							flowing
							hoverable
							on="hover"
						>
							<Typography variant="h4" sx={{ margin: '0 5px 0 5px', display: 'inline' }} color="text.secondary">
								Get Started <RocketLaunchIcon />
							</Typography>
							<BorderLinearProgress variant="determinate" sx={{ width: '80%', display: 'inline-block' }} size={40} value={percentage} />
							<Typography variant="body2" sx={{ margin: '0 5px 0 5px', display: 'inline' }} color="text.secondary">{`${Math.round(
								percentage
							)}%`}</Typography>
							<Divider sx={{ margin: '10px 0 10px 0 ' }}></Divider>
							{_.map(steps, (it, i) => (
								<div key={i}>
									{it.show ? (
										it.completed ? (
											<Box sx={{ flexGrow: 1 }}>
												<Grid container spacing={2}>
													<Grid item xs={1}>
														{it.completed ? (
															<CheckCircleIcon sx={{ fontSize: '30px' }} style={{ color: '#10b981' }} />
														) : (
															<CancelIcon sx={{ fontSize: '30px' }} style={{ color: 'red' }} />
														)}
													</Grid>
													<Grid item xs={11} sx={{ textAlign: 'left' }}>
														{it.completed ? (
															<Typography
																sx={{
																	marginLeft: '15px',
																	marginTop: '3px !important',
																	fontSize: '14px',
																	textDecorationLine: 'line-through',
																	color: 'gray',
																}}
															>
																{it.description}
															</Typography>
														) : (
															<Typography sx={{ marginLeft: '15px', marginTop: '3px !important', fontSize: '14px' }}>
																{it.description}
															</Typography>
														)}

														{!it.completed && it.sub
															? ' (Enter your ' + _.map(it.sub, (it, i) => (!it ? i : '')).join(' ') + ')'
															: ''}
													</Grid>
												</Grid>
											</Box>
										) : (
											<a href={it.link} style={{ marginBottom: 0 }}>
												<Box sx={{ flexGrow: 1 }}>
													<Grid container spacing={2}>
														<Grid item xs={1}>
															{it.completed ? (
																<CheckCircleIcon sx={{ fontSize: '30px' }} style={{ color: '#10b981' }} />
															) : (
																<CancelIcon sx={{ fontSize: '30px' }} style={{ color: 'red' }} />
															)}
														</Grid>
														<Grid item xs={11} sx={{ textAlign: 'left' }}>
															{it.completed ? (
																<Typography
																	sx={{
																		marginLeft: '15px',
																		marginTop: '3px !important',
																		fontSize: '14px',
																		textDecorationLine: 'line-through',
																		color: 'gray',
																	}}
																>
																	{it.description}
																</Typography>
															) : (
																<Typography sx={{ marginLeft: '15px', marginTop: '3px !important', fontSize: '14px' }}>
																	{it.description}{' '}
																	<span style={{ color: 'gray' }}>
																		{!it.completed && it.sub
																			? ' (Enter your ' +
																			  _.map(it.sub, (it, i) => (!it ? i : ''))
																					.join(', ')
																					.replace(', ,', '') +
																			  ')'
																			: ''}
																	</span>
																</Typography>
															)}
														</Grid>
													</Grid>
												</Box>
											</a>
										)
									) : (
										''
									)}
								</div>
							))}
							<Divider textAlign="center" sx={{ marginBottom: '10px', fontSize: '16px' }}>
								Extra
							</Divider>
							{_.map(extraLive, (it, i) => (
								<div key={i}>
									{it.show ? (
										it.completed ? (
											<Box sx={{ flexGrow: 1 }}>
												<Grid container spacing={2}>
													<Grid item xs={1}>
														{it.completed ? (
															<CheckCircleIcon sx={{ fontSize: '30px' }} style={{ color: '#10b981' }} />
														) : (
															<CancelIcon sx={{ fontSize: '30px' }} />
														)}
													</Grid>
													<Grid item xs={11} sx={{ textAlign: 'left' }}>
														{it.completed ? (
															<Typography
																sx={{
																	marginLeft: '15px',
																	marginTop: '3px !important',
																	fontSize: '14px',
																	textDecorationLine: 'line-through',
																	color: 'gray',
																}}
															>
																{it.description}
															</Typography>
														) : (
															<Typography sx={{ marginLeft: '15px', marginTop: '3px !important', fontSize: '14px' }}>
																{it.description}
															</Typography>
														)}

														{!it.completed && it.sub
															? ' (Enter your ' + _.map(it.sub, (it, i) => (!it ? i : '')).join(' ') + ')'
															: ''}
													</Grid>
												</Grid>
											</Box>
										) : (
											<a href={it.link} style={{ marginBottom: 0 }}>
												<Box sx={{ flexGrow: 1 }}>
													<Grid container spacing={2}>
														<Grid item xs={1}>
															{it.completed ? (
																<CheckCircleIcon sx={{ fontSize: '30px' }} style={{ color: '#10b981' }} />
															) : (
																<CancelIcon sx={{ fontSize: '30px' }} style={{ color: 'rgb(226 52 52 / 55%)' }} />
															)}
														</Grid>
														<Grid item xs={11} sx={{ textAlign: 'left' }}>
															{it.completed ? (
																<Typography
																	sx={{
																		marginLeft: '15px',
																		marginTop: '3px !important',
																		fontSize: '14px',
																		textDecorationLine: 'line-through',
																		color: 'gray',
																	}}
																>
																	{it.description}
																</Typography>
															) : (
																<Typography sx={{ marginLeft: '15px', marginTop: '3px !important', fontSize: '14px' }}>
																	{it.description}{' '}
																	<span style={{ color: 'gray' }}>
																		{!it.completed && it.sub
																			? ' (Enter your ' +
																			  _.map(it.sub, (it, i) => (!it ? i : ''))
																					.join(', ')
																					.replace(', ,', '') +
																			  ')'
																			: ''}
																	</span>
																</Typography>
															)}
														</Grid>
													</Grid>
												</Box>
											</a>
										)
									) : (
										''
									)}
								</div>
							))}
						</Popup>
					</div>
				) : (
					''
				)}
				{/* <div
					style={{
						right: 0,
						bottom: 0,
						marginLeft: '10px',
						marginTop: '-10px',
						position: 'fixed',
						height: '60px',
						width: '60px',
						background: '#c54949',
						borderRadius: '50%',
						marginBottom: '15px',
						marginRight: '15px',
						padding: '0',
						cursor: 'pointer',
					}}
				>
					<div style={{ width: '100%', height: '100%', textAlign: 'center', alignItems: 'center', paddingTop: '8px' }}>
						<h1 style={{ color: 'white', fontSize: '14px' }}>Get Started</h1>
					</div>
				</div> */}
			</>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(AccountProgress);
